'use strict';

var modAnimation = function( options ) {
    this.init( options );
};


modAnimation.prototype.init = function( options ) {
    var defaults = {
        onStop: function() {},
        onStopping: function() {},
        element: $(),
        timeline: null,
        timefield: null
    };

    this.options = $.extend( {},
        defaults,
        options || {} );


    this.isPlaying = false;
    this.isStopping = false;

    /*
    this.list = {
        loop: [], // te saraksts ar loop animācijām ko palaidīs katru atsevišķi lai var loop viņiem būt;
        layers: [], // te parastās animācijas kas ir no līdz;
    };
    */

    this.playIndex = 0;
    this.timeFactor = 1;
};

modAnimation.prototype.setAnimation = function( options ) {
    const self = this;

    $.each( options, function( idx, option ) {
        self.options[ idx ] = option;
    } );
};

modAnimation.prototype.setTimeFactor = function( timeFactor ) {
    // 1 ir parasts laiks;
    // 0.5 ir 2x ātrāks;
    // 2 ir 2x lēnāks;
    this.timeFactor = timeFactor;
};


modAnimation.prototype.play = function() {
    this.isPlaying = true;
    this.isStopping = false;

    this.playIndex = 0;
    this.animOpts = this.options.timeline.startOpts;


    this.fpsCounter = new fpsCounter( $('.fpsCounter'), $('.fpsCounterMin'), $('.fpsCounterMax'), $('.fpsCounterAVG') );

    this.playLoop();

    this.resetTimes();
};

modAnimation.prototype.stop = function() {
    this.isStopping = true;
};

modAnimation.prototype.resetTimes = function( max ) {
    const self = this;

    $.each( this.options.timefield, function( idx, field ) {
        field.html( max ? ((self.options.timeline.list[ idx ].duration || 0) / 1000).toFixed(2) : '0.00' );
    } );
};


modAnimation.prototype.transformFix = function( animOpts, factor ) {
    return 'translate('+(animOpts.translate.x * factor)+'px, '+(animOpts.translate.y * factor)+'px) scale('+animOpts.scale.x+') rotate('+animOpts.rotate+'deg)';
};


modAnimation.prototype.playLoop = function() {
    const self = this;

    if (typeof this.options.timeline.list[ this.playIndex ] == 'undefined') {
        this.playFinish();
        return;
    }

    let currentAnimation = this.options.timeline.list[ this.playIndex ];
    let currentTimefield = this.options.timefield ? this.options.timefield[ this.playIndex ] : null;

    let counter = 0,
        maxValue = currentAnimation.duration,
        nowTime,
        css = {};

    this.currentOpts = $.extend(true, {}, this.animOpts);

    $.when(

        $({
            animValue: 0
        }).animate({
            animValue: maxValue
        }, {
            duration: currentAnimation.duration * self.timeFactor,
            easing: 'linear',
            step: function( now ) {

                ++counter;
                self.fpsCounter.step();

                //console.log(self.animOpts);
                nowTime = modAnimCalc.calcOpts( now, maxValue, currentAnimation,  self.animOpts, self.currentOpts, false );

                css.transform = self.transformFix( self.animOpts, self.options.factor );
                modAnimCalc.applyCss( css, self.animOpts );
                self.options.element.css( css );

                if (currentTimefield) {
                    currentTimefield.html( nowTime.toFixed( 2 ) );
                }

                if (self.isStopping) {
                    $( this ).stop();
                    return;
                }
            }
        }).promise()

    ).done(function() {

        ++self.playIndex;

        setTimeout(function() {
            self.playLoop();
        }, 10);
    });

};


modAnimation.prototype.playFinish = function() {
    if (this.isStopping) {
        this.options.onStopping();
    }

    this.isStopping = false;
    this.isPlaying = false;

    this.options.onStop();
};



var modAnimCalc = {}
modAnimCalc.calcOpts = function( now, maxValue, currentAnimation, animOpts, startOpts ) {
    let nowDec, nowTime, subDec;

    if (maxValue == 0) {
        nowDec = 1;
    } else {
        nowDec = now / maxValue;
        if (nowDec > 1) {
            nowDec = 1;
        }
    }
    nowTime = currentAnimation.duration / 1000 * nowDec;

    let currentOpts = $.extend( true, {}, startOpts );

    $.each( currentAnimation.list, function( idx, animation ) {

        if (animation.type == 'move-linear') {
            modAnimCalc.calc_move_linear( animation, currentOpts, startOpts, nowDec, nowTime );
        }

        else if (animation.type == 'move-circular') {
            modAnimCalc.calc_move_circular( animation, currentOpts, startOpts, nowDec, nowTime );
        }

        else if (animation.type == 'move-curved3') {
            modAnimCalc.calc_move_curved3( animation, currentOpts, startOpts, nowDec, nowTime );
        }

        else if (animation.type == 'move-curved4') {
            modAnimCalc.calc_move_curved4( animation, currentOpts, startOpts, nowDec, nowTime );
        }

        // pārējiem var būt citi laiki:
        else if (animation.time.from <= nowTime) {
            if (animation.time.to >= nowTime) {
                if (animation.time.duration == 0) {
                    subDec = 1;
                } else {
                    subDec = (now / 1000 - animation.time.from) / animation.time.duration;
                }

                modAnimCalc.switchTransform( animation, currentOpts, startOpts, nowDec, nowTime, subDec );

            } else if (!animation.done) {
                modAnimCalc.calc_transform_notdone( animation, currentOpts, startOpts, nowDec, nowTime, 1 );
            }
        }

        if (currentOpts.translate) {
            animOpts.translate.x = currentOpts.translate.x;
            animOpts.translate.y = currentOpts.translate.y;
        }
        if (currentOpts.scale) {
            animOpts.scale.x = currentOpts.scale.x;
            animOpts.scale.y = currentOpts.scale.y;
        }
        if (typeof currentOpts.rotate != 'undefined') {
            animOpts.rotate = currentOpts.rotate;
        }

        animOpts.opacity = currentOpts.opacity;

        if (typeof currentOpts.blurall != 'undefined') {
            animOpts.blurall = currentOpts.blurall;
        }

    } );

    return nowTime;
};


modAnimCalc.switchTransform = function( animation, currentOpts, startOpts, nowDec, nowTime, subDec ) {
    if (animation.type == 'zoom') {
        modAnimCalc.calc_transform_zoom( animation, currentOpts, startOpts, nowDec, nowTime, subDec );
    }
    else if (animation.type == 'opacity') {
        modAnimCalc.calc_transform_opacity( animation, currentOpts, startOpts, nowDec, nowTime, subDec );
    }
    else if (animation.type == 'rotate') {
        modAnimCalc.calc_transform_rotate( animation, currentOpts, startOpts, nowDec, nowTime, subDec );
    }
    else if (animation.type == 'blurall') {
        modAnimCalc.calc_transform_blurall( animation, currentOpts, startOpts, nowDec, nowTime, subDec );
    }
    else if (animation.type == 'size') {

    }
};


modAnimCalc.calcToX = function( cx, r, angle ) {
    return cx + r * Math.cos(modAnimCalc.fixAngle(angle) * Math.PI / 180);
};
modAnimCalc.calcToY = function( cy, r, angle ) {
    return cy + r * Math.sin(modAnimCalc.fixAngle(angle) * Math.PI / 180);
};
modAnimCalc.fixAngle = function( angle ) {
    return angle > 360 ? angle - Math.floor(angle / 360) * 360 : (angle < -360 ? angle + Math.floor(Math.abs(angle) / 360) * 360 : angle);
};
modAnimCalc.calcCurve = function( points, nowDec ) {
    let subPoints = [];

    subPoints.push({
        x: points[0].x + (points[1].x - points[0].x) * nowDec,
        y: points[0].y + (points[1].y - points[0].y) * nowDec
    });

    for ( let i = 1; i < points.length - 1; ++i ) {
        subPoints.push({
            x: points[i].x + (points[i+1].x - points[i].x) * nowDec,
            y: points[i].y + (points[i+1].y - points[i].y) * nowDec
        });
    }

    if (points.length <= 3) {
        return {
            x: subPoints[0].x + (subPoints[1].x-subPoints[0].x) * nowDec,
            y: subPoints[0].y + (subPoints[1].y-subPoints[0].y) * nowDec
        }
    }
    if (subPoints.length > 2) {
        return modAnimCalc.calcCurve( subPoints, nowDec );
    }
};

modAnimCalc.calc_move_linear = function( animation, currentOpts, startOpts, nowDec, nowTime ) {
    if (animation.value.x.diff) {
        currentOpts.translate.x = currentOpts.translate.x + animation.value.x.diff * nowDec;
    }
    if (animation.value.y.diff) {
        currentOpts.translate.y = currentOpts.translate.y + animation.value.y.diff * nowDec;
    }
};

modAnimCalc.calc_move_circular = function( animation, currentOpts, startOpts, nowDec, nowTime ) {
    if (animation.value.angleDiff != undefined) {
        const angleCurrent = animation.value.angleCurr + (animation.value.angleDiff * nowDec);

        currentOpts.translate.x = modAnimCalc.calcToX( animation.value.cx, animation.value.r, angleCurrent );
        currentOpts.translate.y = modAnimCalc.calcToY( animation.value.cy, animation.value.r, angleCurrent );
    }
};

modAnimCalc.calc_move_curved3 = function( animation, currentOpts, startOpts, nowDec, nowTime ) {
    let clc = modAnimCalc.calcCurve( animation.value.points, nowDec );

    currentOpts.translate.x = clc.x;
    currentOpts.translate.y = clc.y;
};

modAnimCalc.calc_move_curved4 = function( animation, currentOpts, startOpts, nowDec, nowTime ) {
    let clc = modAnimCalc.calcCurve( animation.value.points, nowDec );

    currentOpts.translate.x = clc.x;
    currentOpts.translate.y = clc.y;
};


modAnimCalc.calc_transform_zoom = function( animation, currentOpts, startOpts, nowDec, nowTime, subDec ) {
    currentOpts.scale.x = currentOpts.scale.y = currentOpts.scale.x + ((animation.valuediff / 100) * subDec);
};

modAnimCalc.calc_transform_opacity = function( animation, currentOpts, startOpts, nowDec, nowTime, subDec ) {
    currentOpts.opacity = currentOpts.opacity + ((animation.valuediff / 100) * subDec);
};

modAnimCalc.calc_transform_rotate = function( animation, currentOpts, startOpts, nowDec, nowTime, subDec ) {
    currentOpts.rotate = currentOpts.rotate + ((animation.valuediff) * subDec);
};

modAnimCalc.calc_transform_blurall = function( animation, currentOpts, startOpts, nowDec, nowTime, subDec ) {
    currentOpts.blurall = currentOpts.blurall + ((animation.valuediff) * subDec);
};


modAnimCalc.calc_transform_notdone = function( animation, currentOpts, startOpts, nowDec, nowTime, subDec ) {
    animation.done = true;

    if (animation.type == 'zoom') {
        currentOpts.scale.x = currentOpts.scale.y = currentOpts.scale.x + (animation.valuediff / 100);
        startOpts.scale.x = startOpts.scale.x = currentOpts.scale.x;
        return;
    }

    if (animation.type == 'opacity') {
        currentOpts.opacity = currentOpts.opacity + (animation.valuediff / 100);
        startOpts.opacity = currentOpts.opacity;
        return;
    }

    if (animation.type == 'rotate') {
        currentOpts.rotate = currentOpts.rotate + animation.valuediff;
        startOpts.rotate = currentOpts.rotate;
        return;
    }

    if (animation.type == 'blurall') {
        currentOpts.blurall = currentOpts.blurall + animation.valuediff;
        startOpts.blurall = currentOpts.blurall;
        return;
    }
};

modAnimCalc.applyCss = function( css, animOpts ) {
    css.opacity = animOpts.opacity === undefined ? 1 : animOpts.opacity;

    if (animOpts.blurall !== undefined) {
        css.filter = 'blur('+animOpts.blurall+'px)';
    }

};


window.modAnimCalc = modAnimCalc;